var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-fullscreen-layout"},[_c('v-app',[_c('main',{staticClass:"service-fullscreen-scroll"},[_c('router-view')],1),_c('notifications',{attrs:{"group":"notify","position":"bottom center"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }